import { render } from "./ClientAuthorizeModal.vue?vue&type=template&id=c110bb20"
import script from "./ClientAuthorizeModal.vue?vue&type=script&lang=js"
export * from "./ClientAuthorizeModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__